import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where
} from "firebase/firestore";
import { db } from "../utils/firebase-config";
import type { LayoutState } from "../reducers/layoutReducer";

/**
 * A layout as stored in Firestore: the layout slice plus the owning uid, with
 * richTexts flattened to a JSON string.
 */
export type PersistedLayout = Partial<Omit<LayoutState, "richTexts">> & {
  uid: string;
  richTexts?: string;
};

export function writeLayout(layout: PersistedLayout) {
  return addDoc(collection(db, "layouts"), layout);
}

export function updateLayout(id: string, layout: PersistedLayout) {
  return updateDoc(doc(db, "layouts", id), layout).then(() => undefined);
}

export function queryLayoutByUid(uid: string) {
  return getDocs(query(collection(db, "layouts"), where("uid", "==", uid)));
}
